import React from 'react';

import NearMissList from './List';
export default function Index() {
  return (
    <>
      <NearMissList />
    </>
  );
}
